/**
 * Directions Sliders JavaScript
 * Based on Bento Slider logic
 */

class DirectionsSlider {
  constructor(container) {
    this.container = container;
    this.slides = container.querySelectorAll('.directions-catalog-right__slide, .directions-catalog-left__slide, .directions-brand__slide, .directions-bento__slide') || 
                 container.querySelectorAll('.directions-catalog-right__slider-container .directions-catalog-right__slide, .directions-catalog-left__slider-container .directions-catalog-left__slide, .directions-brand__slider-container .directions-brand__slide, .directions-bento__slider-container .directions-bento__slide');
    this.paginationItems = container.querySelectorAll('.directions-catalog-right__pagination-item, .directions-catalog-left__pagination-item, .directions-brand__pagination-item, .directions-bento__pagination-item') || 
                          container.querySelectorAll('.directions-catalog-right__slider-container .directions-catalog-right__pagination-item, .directions-catalog-left__slider-container .directions-catalog-left__pagination-item, .directions-brand__slider-container .directions-brand__pagination-item, .directions-bento__slider-container .directions-bento__pagination-item');
    this.progressBars = container.querySelectorAll('.directions-catalog-right__pagination-progress, .directions-catalog-left__pagination-progress, .directions-brand__pagination-progress, .directions-bento__pagination-progress') || 
                       container.querySelectorAll('.directions-catalog-right__slider-container .directions-catalog-right__pagination-progress, .directions-catalog-left__slider-container .directions-catalog-left__pagination-progress, .directions-brand__slider-container .directions-brand__pagination-progress, .directions-bento__slider-container .directions-bento__pagination-progress');
    this.prevButton = container.querySelector('.directions-catalog-right__slider-btn--prev, .directions-catalog-left__slider-btn--prev, .directions-brand__slider-btn--prev, .directions-bento__slider-btn--prev') || 
                     container.querySelector('.directions-catalog-right__slider-container .directions-catalog-right__slider-btn--prev, .directions-catalog-left__slider-container .directions-catalog-left__slider-btn--prev, .directions-brand__slider-container .directions-brand__slider-btn--prev, .directions-bento__slider-container .directions-bento__slider-btn--prev');
    this.nextButton = container.querySelector('.directions-catalog-right__slider-btn--next, .directions-catalog-left__slider-btn--next, .directions-brand__slider-btn--next, .directions-bento__slider-btn--next') || 
                     container.querySelector('.directions-catalog-right__slider-container .directions-catalog-right__slider-btn--next, .directions-catalog-left__slider-container .directions-catalog-left__slider-btn--next, .directions-brand__slider-container .directions-brand__slider-btn--next, .directions-bento__slider-container .directions-bento__slider-btn--next');
    
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.autoPlayInterval = null;
    this.progressInterval = null;
    this.slideDuration = 5000; // 5 секунд
    this.progressUpdateInterval = 50; // Обновление прогресса каждые 50мс
    
    this.init();
  }
  
  init() {
    if (this.totalSlides <= 1) {
      // Скрываем кнопки навигации и пагинацию если слайд только один
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.nextButton) this.nextButton.style.display = 'none';
      if (this.container.querySelector('[class*="__pagination"]')) {
        this.container.querySelector('[class*="__pagination"]').style.display = 'none';
      }
      return;
    }
    
    // Скрываем стрелки на мобильных устройствах
    if (window.innerWidth <= 768) {
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.nextButton) this.nextButton.style.display = 'none';
    }
    
    // Определяем тип слайдера по первому слайду
    const firstSlide = this.slides[0];
    const isRightSlider = firstSlide && firstSlide.classList.contains('directions-catalog-right__slide');
    const isLeftSlider = firstSlide && firstSlide.classList.contains('directions-catalog-left__slide');
    const isBrandSlider = firstSlide && firstSlide.classList.contains('directions-brand__slide');
    const isBentoSlider = firstSlide && firstSlide.classList.contains('directions-bento__slide');
    
    // Проверяем, есть ли уже активный слайд (из HTML)
    const hasActiveSlide = Array.from(this.slides).some(slide => 
      slide.classList.contains('directions-catalog-right__slide--active') || 
      slide.classList.contains('directions-catalog-left__slide--active') ||
      slide.classList.contains('directions-brand__slide--active') ||
      slide.classList.contains('directions-bento__slide--active')
    );
    
    if (!hasActiveSlide) {
      // Скрываем все слайды кроме первого
      this.slides.forEach((slide, index) => {
        if (index === 0) {
          if (isRightSlider) {
            slide.classList.add('directions-catalog-right__slide--active');
          } else if (isLeftSlider) {
            slide.classList.add('directions-catalog-left__slide--active');
          } else if (isBrandSlider) {
            slide.classList.add('directions-brand__slide--active');
          } else if (isBentoSlider) {
            slide.classList.add('directions-bento__slide--active');
          }
        } else {
          slide.classList.remove('directions-catalog-right__slide--active', 'directions-catalog-left__slide--active', 'directions-brand__slide--active', 'directions-bento__slide--active');
        }
      });
      
      // Активируем первую пагинацию
      this.paginationItems.forEach((item, index) => {
        if (index === 0) {
          if (isRightSlider) {
            item.classList.add('directions-catalog-right__pagination-item--active');
          } else if (isLeftSlider) {
            item.classList.add('directions-catalog-left__pagination-item--active');
          } else if (isBrandSlider) {
            item.classList.add('directions-brand__pagination-item--active');
          } else if (isBentoSlider) {
            item.classList.add('directions-bento__pagination-item--active');
          }
        } else {
          item.classList.remove('directions-catalog-right__pagination-item--active', 'directions-catalog-left__pagination-item--active', 'directions-brand__pagination-item--active', 'directions-bento__pagination-item--active');
        }
      });
    }
    
    this.bindEvents();
    this.startAutoPlay();
  }
  
  bindEvents() {
    // Навигационные кнопки
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.previousSlide());
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextSlide());
    }
    
    // Пагинация
    this.paginationItems.forEach((item, index) => {
      item.addEventListener('click', () => this.goToSlide(index));
    });
    
    // Пауза при наведении
    this.container.addEventListener('mouseenter', () => this.pauseAutoPlay());
    this.container.addEventListener('mouseleave', () => this.resumeAutoPlay());
    
    // Пауза при фокусе на элементах внутри слайдера
    this.container.addEventListener('focusin', () => this.pauseAutoPlay());
    this.container.addEventListener('focusout', () => this.resumeAutoPlay());
    
    // Свайп-навигация для мобильных устройств
    this.bindSwipeEvents();
  }
  
  goToSlide(index) {
    this.stopAutoPlay();
    this.currentSlide = index;
    this.updateSlider();
    this.startAutoPlay();
  }
  
  nextSlide() {
    this.stopAutoPlay();
    
    if (this.currentSlide === this.totalSlides - 1) {
      this.currentSlide = 0;
    } else {
      this.currentSlide++;
    }
    this.updateSlider();
    this.startAutoPlay();
  }
  
  previousSlide() {
    this.stopAutoPlay();
    if (this.currentSlide === 0) {
      this.currentSlide = this.totalSlides - 1;
    } else {
      this.currentSlide--;
    }
    this.updateSlider();
    this.startAutoPlay();
  }
  
  updateSlider() {
    // Определяем тип слайдера
    const firstSlide = this.slides[0];
    const isRightSlider = firstSlide && firstSlide.classList.contains('directions-catalog-right__slide');
    const isLeftSlider = firstSlide && firstSlide.classList.contains('directions-catalog-left__slide');
    const isBrandSlider = firstSlide && firstSlide.classList.contains('directions-brand__slide');
    const isBentoSlider = firstSlide && firstSlide.classList.contains('directions-bento__slide');
    
    this.slides.forEach((slide, index) => {
      if (index === this.currentSlide) {
        if (isRightSlider) {
          slide.classList.add('directions-catalog-right__slide--active');
        } else if (isLeftSlider) {
          slide.classList.add('directions-catalog-left__slide--active');
        } else if (isBrandSlider) {
          slide.classList.add('directions-brand__slide--active');
        } else if (isBentoSlider) {
          slide.classList.add('directions-bento__slide--active');
        }
      } else {
        slide.classList.remove('directions-catalog-right__slide--active', 'directions-catalog-left__slide--active', 'directions-brand__slide--active', 'directions-bento__slide--active');
      }
    });
    
    this.paginationItems.forEach((item, index) => {
      if (index === this.currentSlide) {
        if (isRightSlider) {
          item.classList.add('directions-catalog-right__pagination-item--active');
        } else if (isLeftSlider) {
          item.classList.add('directions-catalog-left__pagination-item--active');
        } else if (isBrandSlider) {
          item.classList.add('directions-brand__pagination-item--active');
        } else if (isBentoSlider) {
          item.classList.add('directions-bento__pagination-item--active');
        }
      } else {
        item.classList.remove('directions-catalog-right__pagination-item--active', 'directions-catalog-left__pagination-item--active', 'directions-brand__pagination-item--active', 'directions-bento__pagination-item--active');
        // Сбрасываем прогресс для неактивных слайдов
        if (this.progressBars[index]) {
          this.progressBars[index].style.width = '0%';
        }
      }
    });
    
    // Запускаем прогресс для активного слайда
    this.startProgress();
  }
  
  startAutoPlay() {
    if (this.autoPlayInterval) return;
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, this.slideDuration);
    this.startProgress();
  }
  
  stopAutoPlay() {
    clearInterval(this.autoPlayInterval);
    clearInterval(this.progressInterval);
    this.autoPlayInterval = null;
    this.progressInterval = null;
  }
  
  pauseAutoPlay() {
    // Останавливаем только автоплей, но сохраняем прогресс
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
    
    // Останавливаем прогресс, но не сбрасываем его
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  }
  
  resumeAutoPlay() {
    // Возобновляем автоплей и прогресс
    this.startAutoPlay();
  }
  
  startProgress() {
    if (this.progressBars.length === 0) return;
    
    const activeProgressBar = this.progressBars[this.currentSlide];
    if (!activeProgressBar) return;
    
    // Останавливаем предыдущий прогресс если есть
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
    
    // Всегда начинаем с 0 для нового слайда
    activeProgressBar.style.width = '0%';
    const startTime = Date.now();
    const duration = this.slideDuration;
    
    this.progressInterval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const targetProgress = (elapsed / duration) * 100;
      
      if (targetProgress >= 100) {
        activeProgressBar.style.width = '100%';
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      } else {
        activeProgressBar.style.width = Math.min(targetProgress, 100) + '%';
      }
    }, 16); // 60fps для плавности
  }
  
  resetProgress() {
    this.progressBars.forEach(bar => {
      bar.style.width = '0%';
    });
  }
  
  bindSwipeEvents() {
    let startX = 0;
    let startY = 0;
    let endX = 0;
    let endY = 0;
    let isSwipe = false;
    
    // Touch события
    this.container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isSwipe = false;
    }, { passive: true });
    
    this.container.addEventListener('touchmove', (e) => {
      if (!startX || !startY) return;
      
      endX = e.touches[0].clientX;
      endY = e.touches[0].clientY;
      
      const diffX = Math.abs(startX - endX);
      const diffY = Math.abs(startY - endY);
      
      // Определяем, что это свайп, а не скролл
      if (diffX > diffY && diffX > 10) {
        isSwipe = true;
        e.preventDefault();
      }
    }, { passive: false });
    
    this.container.addEventListener('touchend', (e) => {
      if (!isSwipe || !startX || !endX) return;
      
      const diffX = startX - endX;
      const minSwipeDistance = 50;
      
      if (Math.abs(diffX) > minSwipeDistance) {
        if (diffX > 0) {
          // Свайп влево - следующий слайд
          this.nextSlide();
        } else {
          // Свайп вправо - предыдущий слайд
          this.previousSlide();
        }
      }
      
      // Сброс значений
      startX = 0;
      startY = 0;
      endX = 0;
      endY = 0;
      isSwipe = false;
    }, { passive: true });
  }
  
  destroy() {
    this.stopAutoPlay();
    
    // Удаляем обработчики событий
    if (this.prevButton) {
      this.prevButton.removeEventListener('click', this.previousSlide);
    }
    
    if (this.nextButton) {
      this.nextButton.removeEventListener('click', this.nextSlide);
    }
    
    this.paginationItems.forEach((item, index) => {
      item.removeEventListener('click', () => this.goToSlide(index));
    });
    
    this.container.removeEventListener('mouseenter', this.pauseAutoPlay);
    this.container.removeEventListener('mouseleave', this.startAutoPlay);
    this.container.removeEventListener('focusin', this.pauseAutoPlay);
    this.container.removeEventListener('focusout', this.startAutoPlay);
  }
}

// Инициализация слайдеров при загрузке DOM
document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.directions-catalog-right__slider, .directions-catalog-left__slider, .directions-brand__slider, .directions-bento__slider');
  
  sliders.forEach(slider => {
    if (!slider.directionsSliderInstance) {
      slider.directionsSliderInstance = new DirectionsSlider(slider);
    }
  });
});

// Инициализация для динамически добавленного контента
if (typeof window !== 'undefined') {
  window.initDirectionsSliders = function() {
    const sliders = document.querySelectorAll('.directions-catalog-right__slider, .directions-catalog-left__slider, .directions-brand__slider, .directions-bento__slider');
    
    sliders.forEach(slider => {
      if (!slider.directionsSliderInstance) {
        slider.directionsSliderInstance = new DirectionsSlider(slider);
      }
    });
  };
}